import React, { useEffect, useState } from 'react';
import './UploadStallImage.scss';
import { Button, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Fab, Input, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import { AlertService, general, http, localstorage } from '../../fx-core';
import dummyImage from "../../../assets/images/dummy.png";
import CameraAltIcon from '@material-ui/icons/CameraAlt';

export default function UploadStallImage(props) {
    const [communityId, setCommunityId] = useState(parseInt(localstorage.getItem('communityId')));
    const [uploadImageData, setUploadImageData] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [newTitle, setNewTitle] = useState("");
    const [newIsActive, setNewIsActive] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const handleClose = () => {
        props.closeStallImage();
    }

    const GetStallBanners = () => {
        try {
            let inputData = {
                stallId: props.stallId,
                communityId: communityId
            }
            let apiOptions = {
                url: 'stallbanner/query',
                data: inputData
            }
            http.post(apiOptions).then(res => {
                const result = res.data;
                const updated = result.map(item => ({
                    ...item,
                    imageUrl: general.getImageUrl(item.imagePath),
                    isEditing: false
                }));
                setUploadImageData(updated);
            });
        } catch (error) {
            console.log("Error fetching image data", error);
            AlertService.showErrorMsg("Failed to fetch banner data");
        }
    }

    const openAddDialog = () => {
        setOpenDialog(true);
        setPreviewUrl(null);
        setSelectedFile(null);
        setNewTitle("");
        setNewIsActive(false);
    };

    const closeAddDialog = () => {
        setOpenDialog(false);
    };

    const handleNewFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            // Create a preview URL
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const addNewStallBanner = () => {
        // Validate inputs
        if (!selectedFile) {
            AlertService.showErrorMsg("Please select an image file");
            return;
        }

        if (!newTitle) {
            setNewTitle('New Banner'); // Set default title if empty
        }
        
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('communityId', communityId);
        formData.append('stallId', props.stallId);
        formData.append('title', newTitle || 'New Banner');
        formData.append('isActive', newIsActive);

        let apiOptions = {
            url: 'stallbanner/savewithimage',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        http.post(apiOptions).then(res => {
            // Reset form fields
            setSelectedFile(null);
            setPreviewUrl(null);
            setNewTitle("");
            setNewIsActive(false);
            setOpenDialog(false);
            
            GetStallBanners(); // Refresh banner list
            AlertService.showSuccessMsg("Banner added successfully");
        }).catch(error => {
            console.error("Error adding banner:", error);
            AlertService.showErrorMsg("Failed to add banner");
        });
    };
    
    const handleFileChange = (event, id) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);
        formData.append('id', id);

        let apiOptions = {
            url: 'stallbanner/saveimage',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }

        http.put(apiOptions).then(res => {
            AlertService.showSuccessMsg("Image uploaded successfully");
            GetStallBanners();
        }).catch(error => {
            console.error("Error uploading image:", error);
            AlertService.showErrorMsg("Failed to upload image");
        });
    }

    const handleDelete = (id) => {
        let apiOptions = {
            url: `stallbanner/${id}`
        }
        http.delete(apiOptions).then(res => {
            AlertService.showSuccessMsg("Banner deleted successfully");
            setUploadImageData(prev => prev.filter(item => item.id !== id));
        }).catch(error => {
            console.error("Error deleting banner:", error);
            AlertService.showErrorMsg("Failed to delete banner");
        });
    }

    const startEditing = (id) => {
        setUploadImageData(prev => prev.map(item => ({
            ...item,
            isEditing: item.id === id
        })));
        const itemToEdit = uploadImageData.find(item => item.id === id);
        if (itemToEdit) {
            setNewTitle(itemToEdit.title);
            setNewIsActive(itemToEdit.isActive);
            setEditingId(id);
        }
    }

    
    const saveChanges = (id) => {
        let inputData = {
            id: id,
            communityId: communityId,
            stallId: props.stallId,
            title: newTitle,
            isActive: newIsActive
        }
        let apiOptions = {
            url: 'stallbanner/save',
            data: inputData
        }
        http.post(apiOptions).then(res => {
            AlertService.showSuccessMsg("Banner updated successfully");
            setUploadImageData(prev => prev.map(item => ({
                ...item,
                isEditing: false,
                title: item.id === id ? newTitle : item.title,
                isActive: item.id === id ? newIsActive : item.isActive
            })));
            setEditingId(null);
        }).catch(error => {
            console.error("Error updating banner:", error);
            AlertService.showErrorMsg("Failed to update banner");
        });
    }

    useEffect(() => {
        GetStallBanners();
    }, []);

    return (
        <div className='communityuploadbanner-ui'>
            <div className='row title-font py-1 justify-content-between px-2 drawer-header'>
                <span className="col-11">
                    <span>Stall Banners</span>
                </span>
                <span className="col-1 text-center">
                    <i className="fas fa-times-circle font-16 pointer" onClick={handleClose}></i>
                </span>
            </div>
            
            {/* <div className="banner-dimensions">
                <div className="image-placeholder">
                    Banner Image
                </div>
                <div className="banner-size-text">
                    442 x 205
                </div>
                <div className="dimension-info">
                    <p><b>File format - </b>png, jpg, jpeg</p>
                </div>
            </div> */}

            <div>
                {
                    uploadImageData.length ===0 && 
                    <span className='d-flex justify-content-end mr-4 pr-1 p-2 mt-4 '>
                    <Fab
                        variant="extended"
                        size="medium"
                        color="primary"
                        onClick={openAddDialog}
                    >
                        <i className="fas fa-plus pr-2"></i>
                        Add
                    </Fab>
                </span>  
                }
               
            </div>

            {/* Banner Table */}
            <div className='mx-3 py-4'>
                <div className='my-4 stall-timing-scroll'>
                    <TableContainer component={Paper} className="table-container">
                        <Table stickyHeader size="small" className='table-striped'>
                            <TableHead>
                                <TableRow className='TableRow'>
                                    <TableCell>Upload Image</TableCell>
                                    <TableCell>Banner Name</TableCell>
                                    <TableCell>Active</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {uploadImageData.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            {row.imageUrl ? (
                                                <div className="upload-sample">
                                                    <img src={row.imageUrl} alt="Upload" width={80} />
                                                    <div className="text-center camera-align">
                                                        <label htmlFor={`file-upload-${row.id}`}>
                                                            <CameraAltIcon className='pointer' />
                                                        </label>
                                                        <input
                                                            id={`file-upload-${row.id}`}
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, row.id)}
                                                            accept="image/png, image/jpeg, image/jpg"
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="upload-sample">
                                                    <img src={dummyImage} alt="dummy" height={100} width={100} />
                                                    <div className="text-center camera-align">
                                                        <label htmlFor={`file-upload-${row.id}`}>
                                                            <CameraAltIcon className='pointer' />
                                                        </label>
                                                        <input
                                                            id={`file-upload-${row.id}`}
                                                            type="file"
                                                            style={{ display: 'none' }}
                                                            onChange={(e) => handleFileChange(e, row.id)}
                                                            accept="image/png, image/jpeg, image/jpg"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.isEditing ? (
                                                <Input
                                                    type='text'
                                                    value={newTitle}
                                                    onChange={(e) => setNewTitle(e.target.value)}
                                                />
                                            ) : (
                                                row.title
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.isEditing ? (
                                                <Checkbox
                                                    checked={newIsActive}
                                                    onChange={(e) => setNewIsActive(e.target.checked)}
                                                    color="primary"
                                                />
                                            ) : (
                                                <Checkbox
                                                    checked={row.isActive}
                                                    disabled
                                                    color="primary"
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {row.isEditing ? (
                                                <>
                                                    <IconButton onClick={() => saveChanges(row.id)}>
                                                        <i className="fas fa-save"></i>
                                                    </IconButton>
                                                    <IconButton onClick={() => {
                                                        setUploadImageData(prev => prev.map(item => ({
                                                            ...item,
                                                            isEditing: false
                                                        })));
                                                        setEditingId(null);
                                                    }}>
                                                        <i className="fas fa-times"></i>
                                                    </IconButton>
                                                </>
                                            ) : (
                                                <>
                                                    <IconButton onClick={() => startEditing(row.id)}>
                                                        <Edit />
                                                    </IconButton>
                                                    <IconButton onClick={() => handleDelete(row.id)}>
                                                        <Delete />
                                                    </IconButton>
                                                </>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

            {/* Add Banner Dialog */}
            <Dialog open={openDialog} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth>
    <DialogTitle id="form-dialog-title">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Add New Banner</span>
            <i
                className="fas fa-times-circle font-20 pointer"
                onClick={closeAddDialog}
                style={{ cursor: 'pointer', color: '#666' }}
            ></i>
        </div>
    </DialogTitle>

    <DialogContent>
        <DialogContentText>
            Please select an image file (442 x 205) and provide banner details.
        </DialogContentText>

        <div className="mb-3 text-center">
            {previewUrl ? (
                <div className="preview-container">
                    <img
                        src={previewUrl}
                        alt="Preview"
                        style={{ maxWidth: '100%', maxHeight: '200px' }}
                    />
                </div>
            ) : (
                <div
                    className="upload-placeholder"
                    style={{
                        padding: '20px',
                        border: '1px dashed #ccc',
                        borderRadius: '4px',
                        textAlign: 'center'
                    }}
                >
                    <CameraAltIcon style={{ fontSize: 40 }} />
                    <p>No image selected</p>
                </div>
            )}

            <label htmlFor="new-file-upload" className="mt-2">
                <Button variant="contained" color="primary" component="span">
                    Choose File
                </Button>
            </label>
            <input
                id="new-file-upload"
                type="file"
                style={{ display: 'none' }}
                onChange={handleNewFileChange}
                accept="image/png, image/jpeg, image/jpg"
            />
        </div>

        <TextField
            autoFocus
            margin="dense"
            id="banner-title"
            label="Banner Title"
            type="text"
            fullWidth
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
        />

        <div className="mt-3">
            <Checkbox
                checked={newIsActive}
                onChange={(e) => setNewIsActive(e.target.checked)}
                color="primary"
                id="banner-active"
            />
            <label htmlFor="banner-active">Active</label>
        </div>
    </DialogContent>

    <DialogActions>
        <Button onClick={closeAddDialog} color="secondary">
            Cancel
        </Button>
        <Button onClick={addNewStallBanner} color="primary" variant="contained">
            Add Banner
        </Button>
    </DialogActions>
</Dialog>

        </div>
    );
}